import $ from 'jquery';
import pubsub from 'pubsub-js';
import Page from 'js/lib/page';

export default class Sort extends Page {
  init() {
    this.state = {};
    this.param = {};
    this.methods = {};
    this.elements({
      amount: '.js-sort-amount'
    });
    this.events();
  }
  events() {
    pubsub.subscribe('content.update', (t, { amount }) =>
      this.updateAmount(amount)
    );
  }
  updateAmount(amount) {
    this.$.amount.text(amount);
  }
}

Page.make(Sort, '.js-sort');
